/** @format */

'use strict';

angular
	.module('emsApp')
	.controller('LocationTemplateEventArticleDialogController', function(
		$scope,
		$rootScope,
		$timeout,
		$state,
		$stateParams,
		$uibModalInstance,
		$parse,
		entity,
		LocationTemplateEventArticleFactory,
		AlertService,
		NoPagingLocationTemplateEventArticleFactory,
		NoPagingLocationFactory,
		NoPagingTemplateEventFactory,
		NoPagingPredefinedArticleTypeFactory,
		NoPagingArticleFactory,
		LocationTemplateEventArticleFindArticleFilteredByArticleFactory
	) {
		$scope.locationTemplateEventArticle = entity;

		if ($rootScope.isDefinedAndNotNull($stateParams.mappedBy)) {
			$scope.mappedBy = $stateParams.mappedBy;
		}

		/**
		 * Checks if the page is in create or edit state based on the scope model and it's id value
		 */
		$scope.isEdit = function() {
			return (
				$rootScope.isDefinedAndNotNull($scope.locationTemplateEventArticle) &&
				$rootScope.isDefinedAndNotNull($scope.locationTemplateEventArticle.id)
			);
		};

		$scope.createArticle = function() {
			var referredBy = {
				refName: 'article',
				data: $scope.locationTemplateEventArticle,
			};

			// dismiss the modal, however pass a reason to indicate that we should not navigate back by passing the reason of dismiss
			$uibModalInstance.dismiss('createNew');

			$timeout(function() {
				// we add a little timeout to prevent the modal dismiss not to be ready
				// navigating to new article will add this new locationtemplateeventarticle state to the history stack
				$state.go('locationtemplateeventarticle.list.newArticle', { referredBy: referredBy }, { reload: false });
			}, 100);
		};

		$scope.submitButtonIsActive = true;

		/**
		 * Function to find an item in a list of items based on the parent id if this dialog is opened from a tabbed overview
		 */
		$scope.findItemByParent = function(items, property) {
			//This function preselects and disables the parent reference when called from tab
			if ($stateParams.mappedBy === property && $stateParams.mappedById !== undefined) {
				angular.forEach(items, function(value) {
					// value.id is a number, $stateParams.mappedById is a string, hence we cast the $stateParams.mappedById to a number so we can compare the id using the typesafe === operator
					if (value.id === _.toNumber($stateParams.mappedById)) {
						var model = $parse('locationTemplateEventArticle.' + property);
						model.assign($scope, value);
					}
				});
			}
		};

		// --- start default implementation
		/**
		 * This function queries all entities of type Location and checks if this LocationTemplateEventArticle dialog is called in the context of Location.
		 * If this is the case, we detect the parent entity LocationTemplateEventArticle and select it as model value so it is shown in the dropdown select.
		 */
		$scope.queryLocation = function() {
			return NoPagingLocationFactory.query(function(result) {
				$scope.findItemByParent(result, 'location');
			});
		};
		$scope.locationList = $scope.queryLocation();
		// --- end default implementation

		// --- start default implementation
		/**
		 * This function queries all entities of type TemplateEvent and checks if this LocationTemplateEventArticle dialog is called in the context of TemplateEvent.
		 * If this is the case, we detect the parent entity LocationTemplateEventArticle and select it as model value so it is shown in the dropdown select.
		 */
		$scope.queryTemplateEvent = function() {
			return NoPagingTemplateEventFactory.query(function(result) {
				$scope.findItemByParent(result, 'templateEvent');
			});
		};
		$scope.templateEventList = $scope.queryTemplateEvent();
		// --- end default implementation

		// --- start default implementation
		/**
		 * This function queries all entities of type PredefinedArticleType and checks if this LocationTemplateEventArticle dialog is called in the context of PredefinedArticleType.
		 * If this is the case, we detect the parent entity LocationTemplateEventArticle and select it as model value so it is shown in the dropdown select.
		 */
		$scope.queryPredefinedArticleType = function() {
			return NoPagingPredefinedArticleTypeFactory.query(function(result) {
				$scope.findItemByParent(result, 'predefinedArticleType');
			});
		};
		$scope.predefinedArticleTypeList = $scope.queryPredefinedArticleType();
		// --- end default implementation

		// --- start default implementation
		/**
		 * This function queries all entities of type Article and checks if this LocationTemplateEventArticle dialog is called in the context of Article.
		 * If this is the case, we detect the parent entity LocationTemplateEventArticle and select it as model value so it is shown in the dropdown select.
		 */
		$scope.queryArticle = function() {
			return LocationTemplateEventArticleFindArticleFilteredByArticleFactory.query(function(result) {
				$scope.findItemByParent(result, 'article');
			});
		};
		$scope.articleList = $scope.queryArticle();
		// --- end default implementation

		var onSaveFinishedCallback = function(result) {
			$scope.$emit('emsApp:locationTemplateEventArticleUpdate', result);
			$uibModalInstance.close(result);
			$scope.submitButtonIsActive = true;
		};

		var saveOrUpdateErrorCallback = function(error) {
			console.error('Saving LocationTemplateEventArticle failed', error);
			AlertService.error(error.data.message, error.data.params);
			$scope.submitButtonIsActive = true;
		};

		$scope.save = function() {
			$scope.submitButtonIsActive = false;

			if ($scope.locationTemplateEventArticle.id != null) {
				LocationTemplateEventArticleFactory.update($scope.locationTemplateEventArticle, onSaveFinishedCallback, saveOrUpdateErrorCallback);
			} else {
				LocationTemplateEventArticleFactory.save($scope.locationTemplateEventArticle, onSaveFinishedCallback, saveOrUpdateErrorCallback);
			}
		};

		// called from cancel button in dialog
		$scope.clear = function() {
			// dismiss the modal will eventually trigger HistoryService.back() via $rootScope.back() as the finish result of the modal in the state JS file
			$uibModalInstance.dismiss('cancel');
		};
	});
